import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from './services/account.service';
import { OtherService } from './services/other.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  constructor(
    private accountService: AccountService,
    private router: Router,
    private otherService: OtherService,
  ) {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(r => r.unregister());
      });
    }
  }

  ngOnInit() {
    if (this.otherService.getLocalStorage()?.Id) {
      const model = {
        iTaxiLon_User: this.otherService.getLocalStorage().Id,
        strSession: this.otherService.getLocalStorage().session
      }

      this.accountService.getNewSession(this.otherService.stringNumberToNumber(model)).subscribe((data) => {
        let response = JSON.parse(data.toString());
        let res = response[0] ?? response;
        if (res?.iResult == 0 && res?.ISSessionExpired) {
          this.otherService.logout();
          this.router.navigateByUrl('/login/home');
          return;
        }
        else {
          let userInfo = this.otherService.getLocalStorage();
          userInfo.session = res.strSession;
          localStorage.setItem('db30a17f18d1a8a3l0ifr4z8ab0b02', this.accountService.encrypt(JSON.stringify(userInfo)));
          this.otherService.changeUserLogin_Status(true);
        }
      })
    }

    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true;

    if (isStandalone) {
      document.body.innerHTML = `
      <div style="
        display:flex;
        align-items:center;
        justify-content:center;
        height:100vh;
        text-align:center;
        font-family:sans-serif;
        padding:20px;">
        <div>
          <h2>این نسخه دیگر پشتیبانی نمی‌شود!</h2>
          <p>لطفاً این اپ را از گوشی خود حذف کرده و از نسخه وب استفاده کنید.</p>
          <p>برای حذف: روی آیکن نگه دارید و Remove را انتخاب کنید.</p>
        </div>
      </div>
    `;
    }
  }

}
